const w = window;
const ic = w.Intercom;

const { intercomAppId } = window.globals;

function isPrintablePage() {
  const path = w.location.pathname || '';
  return path.includes('/printable') || path.includes('/pdf/view');
}

if (isPrintablePage()) {
  w.Intercom = () => {};
} else if (typeof ic === 'function') {
  ic('reattach_activator');
  ic('update', { app_id: intercomAppId });
} else {
  const d = document;
  const i = function () {
    i.c(arguments);
  };
  const loadScript = function () {
    const s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = `https://widget.intercom.io/widget/${intercomAppId}`;
    const x = d.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  };

  i.q = [];
  i.c = function (args) {
    i.q.push(args);
  };
  w.Intercom = i;

  if (w.attachEvent) {
    w.attachEvent('onload', loadScript);
  } else {
    w.addEventListener('load', loadScript, false);
  }
}
